/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
==========================================================================================*/

// MAIN COLORS - Mahaka THEME COLORS
let colors = {
	//primary: '#3F65B3',
	primary: '#214486',
	success: '#28C76F',
	danger: '#EA5455',
	warning: '#FF9F43',
	dark: '#1E1E1E',
	secondary: '#009dd4',
	purple: '#BA55D3',
	//purple: '#3F65B3',
	brown: '#8B4513',
	pink: '#ec5284',
	gold: '#E0B83F',
	bronze: "#C07A3A",
	silver: "#C4C4C4",
};

import Vue from 'vue';
import Vuesax from 'vuesax';
Vue.use(Vuesax, {
	theme: {
		colors
	}
});


// CONFIGS
const themeConfig = {
	theme: 'light', // options[String]: 'light'(default), 'dark', 'semi-dark'
	sidebarCollapsed: false, // options[Boolean]: true, false(default)
	navbarColor: "#fff", // options[String]: HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
	navbarType: "floating", // options[String]: floating(default) / static / sticky / hidden
	footerType: "static", // options[String]: static(default) / sticky / hidden
	routerTransition: 'zoom-fade', // options[String]: zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
	disableCustomizer: false, // options[Boolean]: true, false(default)
}

export default themeConfig;